<div class='left_col scroll-view'>
  <div class='navbar nav_title site_title border-none'>
    <img class='img-height' [src]='menuicon' alt='admin logo'/> <span class='title-padding'>{{ 'MENU.PORTAIL' | translate }}</span>
  </div>

  <div class='clearfix' role='separator' aria-label='menu separator'></div>

  <!-- MENU PROFILE -->
  <div class='profile clearfix' role='navigation' routerLink='/home' routerLinkActive='current-page'>
    <div class='profile_pic' role='link' [ngClass]="{ 'nav-toggle-ms': !isToggle, 'nav-toggle-md': isToggle }">
      <img src='assets/images/avatar.png' alt='profile logo' class='img-circle profile_img' />
    </div>
    @if ((loggedAgent$ | async); as loggedAgent) {
      <div class='profile_info'>
        <a routerLink='/home'><span>{{ 'ROLES.' + loggedAgent.role | translate }}</span></a>
        <a routerLink='/home'><h2>{{ loggedAgent.userDetails?.userFirstName }} {{ loggedAgent.userDetails?.userLastName }}</h2></a>
      </div>
    }
  </div>

  <!-- MENU -->
  <div id='sidebar-menu' class='main_menu_side hidden-print main_menu'>
    <div class='menu_section' role='navigation' aria-label='Menu'>
      <h3>{{ 'MENU.TITLE' | translate }}</h3>
      <ul ap-side-menu>
        <!-- USERS -->
        <li ap-side-submenu *apSecure='[Permissions.ACCESS_ALL_ACCOUNTS]'>
          <i class='fa fa-users'></i> {{ 'MENU.USERS.GLOBAL' | translate }}
          <ul ap-side-submenu-items>
            <!-- CREATE USER -->
            @if (accessCreateUser) {
              <li ap-side-menu-item exact='true' linkTo='/users/createuser'>{{ 'MENU.USERS.CREATE_USER_TITLE' | translate }}</li>
            }
            <!-- USERS LIST -->
            <li ap-side-menu-item exact='true' linkTo='/users' *apSecure='[Permissions.ACCESS_ALL_ACCOUNTS]'>{{ 'MENU.USERS.LIST_TITLE' | translate }}</li>
          </ul>
        </li>

        <!-- SUBSCRIPTIONS -->
        <li ap-side-menu-item exact='true' linkTo='/subscriptions' *apSecure='[Permissions.ACCESS_ALL_SUBSCRIPTIONS]'><i class='fa fa-file-text'></i> {{ 'MENU.SUBSCRIPTIONS.GLOBAL' | translate }}</li>

        <!-- USERS ACTIVITIES -->
        <li ap-side-menu-item exact='true' linkTo='/activities' *apSecure='[Permissions.ACCESS_ALL_ACTIVITIES]'><i class='fa fa-bus'></i> {{ 'MENU.ACTIVITIES.GLOBAL' | translate }}</li>

        <!-- TRANSACTIONS -->
        <li ap-side-menu-item exact='true' linkTo='/transactions' *apSecure='[Permissions.ACCESS_ALL_PAYMENTS]'><i class='fa fa-money'></i> {{ 'MENU.TRANSACTIONS.GLOBAL' | translate }}</li>

        <!-- PROFILES -->
        <li ap-side-menu-item exact='true' linkTo='/profile-requests' *apSecure='[Permissions.ACCESS_ALL_PROFILES]'><i class='fa fa-suitcase'></i> {{ 'MENU.PROFILES_REQUEST.GLOBAL' | translate }}</li>

        <!-- VALIDATION REQUESTS -->
        <li ap-side-menu-item exact='true' linkTo='/validation-requests' *apSecure='[Permissions.ACCESS_ALL_IDENTITY_REQUESTS]'><i class='fa fa-archive'></i> {{ 'MENU.VALIDATION_REQUESTS.GLOBAL' | translate }}</li>

        <!-- ACCESS MEDIA -->
        <li ap-side-menu-item exact='true' linkTo='/access-media' *apSecure='[Permissions.ACCESS_ALL_ACCESS_MEDIA]'><i class='fa fa-credit-card'></i> {{ 'MENU.ACCESS_MEDIA.GLOBAL' | translate }}</li>

        <!-- STATS -->
        <li ap-side-menu-item exact='true' linkTo='/statistics' *apSecure='[Permissions.ACCESS_STATISTICS]'><i class='fa fa-bar-chart'></i> {{ 'MENU.STATISTICS.GLOBAL' | translate }}</li>

        <!-- ADMINISTATORS -->
        <li ap-side-submenu *apSecure='[Permissions.ACCESS_ALL_USERS]'>
          <i class='fa fa-shield'></i> {{ 'MENU.ADMINISTRATORS.TITLE' | translate }}
          <ul ap-side-submenu-items>
            <!-- CREATE ADMIN -->
            <li ap-side-menu-item exact='true' linkTo='/administrators/registration'>{{ 'MENU.ADMINISTRATORS.ENLIST' | translate }}</li>
            <!-- ADMIN LIST -->
            <li ap-side-menu-item exact='true' linkTo='/administrators'>{{ 'MENU.ADMINISTRATORS.MANAGE' | translate }}</li>
          </ul>
        </li>

        <!-- MANAGE CONTENT -->
        <li ap-side-submenu *apSecure='[Permissions.ACCESS_ALL_CONSENTS]'>
          <i class='fa fa-th'></i> {{ 'MENU.CONTENTMANAGEMENT.TITLE' | translate }}
          <ul ap-side-submenu-items>
            <!-- CGUV LIST -->
            <li ap-side-menu-item exact='true' linkTo='/content-management/cguv'>{{ 'MENU.CONTENTMANAGEMENT.CGUV.LINK' | translate }}</li>
          </ul>
        </li>

        <!-- PARAMETERS -->
        <li ap-side-submenu *apSecure='[Permissions.ACCESS_APP_CONFIGURATION]'>
          <i class='fa fa-cogs'></i> {{ 'MENU.PARAMETERS.TITLE' | translate }}
          <ul ap-side-submenu-items>
            <!-- APPLICATION CONFIGURATION PROPERTIES -->
            <li ap-side-menu-item exact='true' linkTo='/parameters/module-configuration'>{{ 'MENU.PARAMETERS.MODULE_CONFIGURATION.LINK' | translate }}</li>
          </ul>
        </li>

        <!-- ADMIN TOOLS -->
        <li ap-side-submenu *apSecure='[Permissions.ACCESS_ADMIN_TOOLS]'>
          <i class='fa fa-qq'></i> Admin tools
          <ul ap-side-submenu-items>
            <!-- OPP PAYPAGE -->
            <li ap-side-menu-item exact='true' linkTo='/tools/opp-enrollment'>Opp enrollment</li>
            <!-- OPP ONE CLICK -->
            <li ap-side-menu-item exact='true' linkTo='/tools/opp-one-click'>Opp one click</li>
          </ul>
        </li>
      </ul>
    </div>
  </div>

</div>
